// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__1XXg3","noDropdown":"style_noDropdown__QNhWM","avatar":"style_avatar__qWpey"};